<!-- Sin mat-dialog-title aquí: mdc-dialog__title queda anclado arriba en MDC y separa el texto del spinner. -->
<mat-dialog-content
  class="tiwp-spinner-dialog__body flex flex-col items-center justify-center gap-3 sm:gap-4 overflow-hidden p-6 m-auto min-h-0 w-full max-w-full box-border"
>
  <span
    *ngIf="title"
    class="overflow-hidden font-bold text-4xl colored-text text-center max-w-[min(70vw,24rem)]"
    role="status"
    aria-live="polite"
  >
    {{ title }}
  </span>
  <!-- Mismo centro geométrico: el pequeño antes usaba 50vw/50vh y quedaba descentrado respecto al grande. -->
  <div class="relative h-[100px] w-[100px] shrink-0">
    <mat-progress-spinner
      class="absolute left-1/2 top-1/2 z-0 -translate-x-1/2 -translate-y-1/2 overflow-hidden"
      diameter="100"
      strokeWidth="8"
      [mode]="mode"
      [value]="amount"
    >
    </mat-progress-spinner>
    <mat-spinner
      *ngIf="veryLongTime"
      class="absolute left-1/2 top-1/2 z-[1] -translate-x-1/2 -translate-y-1/2 overflow-hidden"
      diameter="50"
      strokeWidth="8"
    >
    </mat-spinner>
  </div>
</mat-dialog-content>
